<template>
  <div>
    <!-- Template 2 - Modern - Blank for now -->
    <v-card class="glass-section-card mb-6" elevation="0">
      <v-card-subtitle class="section-header d-flex align-center pb-2">
        <v-icon left color="primary">mdi-triangle-outline</v-icon>
        <span class="text-subtitle-1 font-weight-bold">Modern Template</span>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-center pa-12">
            <v-icon size="80" color="grey lighten-1">mdi-cog-outline</v-icon>
            <p class="text-h6 mt-4 grey--text">Postavke za Modern template</p>
            <p class="text-body-2 grey--text">Ovaj template će imati potpuno drugačije postavke i vizualni prikaz.</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'TemplateModern',
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      localSettings: {}
    }
  },
  watch: {
    settings: {
      handler (newSettings) {
        this.localSettings = { ...newSettings }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    emitUpdate () {
      this.$emit('update:settings', this.localSettings)
    }
  }
}
</script>

<style scoped>
/* Template 2 specific styles */
</style>
